/* eslint-disable */

// 处理高德jscode
if (window) {
  window._AMapSecurityConfig = {
    securityJsCode: process.env.VUE_APP_AmapSecret || '',
  }
}

import { bd09togcj02, bd09towgs84 } from '@/business/utils/convertGps'
import { metreToKm } from '@/business/utils/string'
import { getSysType, getIosPosition, isAndroid, isIOS, openSysMap, isH5 } from '@/common/utils/plus'
import AMapLoader from '@amap/amap-jsapi-loader'
import carpng from 'Assets/images/car/car.png'
import positionPicker from 'Assets/images/car/position-picker.png'
import RemoGeoLocation from 'Utils/remogeo'

const AppKey = process.env.VUE_APP_AmapKey||'a459df13ad5d903e04c49241a3f88acb'
export const qqMapAppKey = 'GT5BZ-275CS-7WNO5-6SLIB-OXZQF-4UFBA'
const outlineColor = '#3c825a'

/**
 * 高德地图
 */

class LD_AMap {
  constructor(options = {}) {
    this.containerId = options.id
    this.map = {}
    this.created = options.created
    this.mapEvent = options.mapEvent
    this.mapMount = options.mapMount
    this.completed = options.completed // 地图加载完成钩子
    this.showGeoControl = options.showGeoControl // 是否显示定位按钮
    this.GeoOffset = options.GeoOffset
    this.autoLocationSetCenter = options.autoLocationSetCenter == undefined ? true : false
    this.markerInstance = {}
    this.polylineInstance = {}

    this.center = options.center
    this.zoom = options.zoom
    this.plugins = options.plugins || []
    this.AMapUIPlugins = options.AMapUIPlugins || []

    this.error = options.error
    this.dragMapStopBool = false // 用于 用控件选址时，不触发拖拽选址的moveend事件的回调
    this.moveendEvent = options.moveend // positionPicket 拖拽结束事件
    this.showMarker = options.showMarker //显示隐藏 高德的定位点
    this.load()
  }

  // 加载地图 确保dom加载出来
  load () {
    this.created && this.created()

    AMapLoader.load({ //首次调用 load
      key: AppKey,//首次load key为必填
      version: '2.0',
      plugins: this.plugins,
      AMapUI: {             // 是否加载 AMapUI，缺省不加载
        'version': '1.1',   // AMapUI 缺省 1.1
        'plugins': this.AMapUIPlugins,     // 需要加载的 AMapUI ui插件
      }
    }).then(AMap => {
      this.AMapInstance = AMap
      this.map = new AMap.Map(this.containerId, {
        zoom: this.zoom,
        resizeEnable: true,
        scrollWheel: false,
        center: this.center,
        touchZoomCenter: 1,
        features: ['bg', 'road','point', 'building'],
        mapStyle: "amap://styles/normal"
      })

      this.mapMount && this.mapMount()

      if (this.mapEvent) {
        for (const eventName in this.mapEvent) {
          if (Object.hasOwnProperty.call(this.mapEvent, eventName)) {
            const eventFunc = this.mapEvent[eventName]
            this.map.on(eventName, eventFunc.bind(this, this.map))
          }
        }
      }

      // this.map.setMapStyle('amap://styles/macaron')

      this.location(AMap)
      this.loadPathSimplifier(AMap)
      this.loadPostionPicker()
    }).catch((e) => {
      console.error(e)
    })
  }

  addMarker (opt) {
    if (this.markerInstance[opt.name]) {
      this.map.remove(this.getMarker(opt.name))
    }

    this.markerInstance[opt.name] = new AMap.Marker({
      ...opt
    })

    this.map.add(this.markerInstance[opt.name])

    return this.markerInstance[opt.name]
  }

  getMarker (name) {
    return this.markerInstance[name]
  }

  removeMarker (name) {
    if (this.getMarker(name)) {
      this.map.remove(this.getMarker(name))
      this.markerInstance[name] = null
    }
  }

  /**
   * 创建自定义信息窗体上下车地址覆盖物  行程分钟覆盖物
   * 具体实现 使用点标记模拟自定义窗体
   * @param {String|HTML} content 描述内容，接收html字符串
   * @param {MarkerOptions} opt	构造一个点标记对象，通过MarkerOptions设置点标记对象的属性
   * @param {Boolean} isLink 是否展示右侧箭头并开启点击反馈
   * @returns {Marker} 创建的点标记实例
   */
  createInfoWindow (content, opt, isLink) {
    let contentHTML = `
      <div class="carInfoMarker" ${isLink && 'style="padding-right: 30px;"'}>
        <div class="van-multi-ellipsis--l2">
          ${content}
        </div>
        ${isLink ? '<i class="iconfont iconright"></i>' : ''}
      </div>
    `

    return this.addMarker({
      content: contentHTML,
      ...opt
    })
  }

  addPolyline (opt) {
    if (this.polylineInstance[opt.name]) {
      this.map.remove(this.getPolyline(opt.name))
    }

    this.polylineInstance[opt.name] = new AMap.Polyline({
      map: this.map,
      ...opt
    })
  }

  getPolyline (name) {
    return this.polylineInstance[name]
  }

  location (AMap) {
    if (this.plugins.indexOf('AMap.Geolocation') === -1) return

    AMap.plugin("AMap.Geolocation", async () => {
      var geolocation = new AMap.Geolocation({
        enableHighAccuracy: true, // 是否使用高精度定位，默认：true
        timeout: 10 * 1000, // 设置定位超时时间，默认：无穷大
        noIpLocate: 1,
        buttonOffset: new AMap.Pixel(10, 20), // 定位按钮的停靠位置的偏移量，默认：Pixel(10, 20)
        zoomToAccuracy: true, //  定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
        showMarker: this.showMarker === undefined ? true : this.showMarker, //定位成功后在定位到的位置显示点标记，默认：true
        showCircle: this.showMarker === undefined ? true : this.showMarker, //定位成功后用圆圈表示定位精度范围，默认：true
        panToLocation: this.autoLocationSetCenter, //定位成功后将定位到的位置作为地图中心点，默认：true
        offset: this.GeoOffset ? this.GeoOffset : [18, 420],
        useNative: true,
        buttonPosition: "RB", //定位按钮的排放位置,  RB表示右下
        showButton:
        this.showGeoControl === undefined ? true : this.showGeoControl
      })

      // 在图面添加定位控件，用来获取和展示用户主机所在的经纬度位置
      this.map.addControl(geolocation);

      try {
        if (getSysType() === "10505") {
          try {
            //替换方法
            navigator.geolocation.getCurrentPosition = async function (succHandler, errHandler) {
              try {
                // succHandler 需要传入GPS坐标系的经纬度
                const { coords } = await getIosPosition()

                if (succHandler) {
                  succHandler({
                    coords: coords,
                    timestamp: new Date() * 1
                  })
                }
              } catch (error) {
                if (errHandler) errHandler(error)
              }
            };

          } catch (error) {
            throw error
          }
        } else {
          if (false && AMap.UA.ios && navigator.platform === "iPhone") {
            // ios环境且是h5 切换到使用远程https定位
            console.log("ios环境切换到使用远程https定位");
            //使用远程定位，见 remogeo.js
            var remoGeo = new RemoGeoLocation();
            //替换方法
            navigator.geolocation.getCurrentPosition = function() {
              return remoGeo.getCurrentPosition.apply(remoGeo, arguments);
            };
            //替换方法
            navigator.geolocation.watchPosition = function() {
              return remoGeo.watchPosition.apply(remoGeo, arguments);
            };
          }

        }

        geolocation.getCurrentPosition(
          (status, result) => {
            console.log(6, status, result);
            if (status == "complete") {
              console.log(7);
              onComplete.call(this, result);
            } else {
              console.log(8);
              onError.call(this, result);
            }
          },
          err => {
            console.log(9);
            console.log(err);
            onError.call(this, err);
          }
        )

      } catch (error) {
        console.log(10);
        console.log(error);
        onError.call(this, error);
      }

      async function onComplete (data) {
        console.log("具体的定位信息", data);
        if (this.autoLocationSetCenter) {
          let LngLat = [data.position.lng, data.position.lat];
          this.setCenter(LngLat, "");
        }
        this.completed && this.completed();
      }

      function onError(data) {
        console.log(data);
        this.error && this.error(data);
        this.completed && this.completed();
        // 定位出错
      }
    });
  }

  dragMapStart () {
    this.dragMapStopBool = false
  }

  dragMapStop () {
    this.dragMapStopBool = true
  }

  // 拖拽选址 就是生成选上车地点中间那个定位点
  loadPostionPicker (LngLat) {
      console.log('loadPostionPicker')
      if (this.AMapUIPlugins.indexOf('misc/PositionPicker') === -1) return
      this.positionPickerInstance = new AMapUI.PositionPicker({
          mode: 'dragMap',
          map: this.map,
          iconStyle: { //自定义外观
            url: positionPicker,
            ancher: [24, 40],
            size: [48, 48]
          }
      }).on('success', (positionResult) => {
          console.log('拖拽选址', positionResult)
          if (!this.dragMapStopBool) {
            this.moveendEvent && this.moveendEvent(positionResult)
          }
      }).on('fail', (error) => {
          console.log('拖拽选址异常', error)
      }).start(LngLat)
  }

  // 关闭拖拽选址
  closePositionPicker () {
    this.positionPickerInstance.stop()
  }

  /**
   * 设置地图中心点
   * @param {[Number, Number] | LngLat} pos 要设置中心点的经纬度
   * @param {String} type 用于说明是哪个服务商的坐标,可选值有：gps:GPS原始坐标；baidu：百度经纬度；mapbar：图吧经纬度；
   * @param {Boolean} immediately 是否立即过渡到目标位置
   */
  async setCenter (pos, type, immediately = false) {
    console.log('当前中心点位置：', pos)
    if (type) {
      const { lng, lat } = await LD_AMap.convertFrom(pos, type)
      this.map.setCenter([lng, lat], immediately)
    } else {
      this.map.setCenter(pos, immediately)
    }
  }

  /**
   * 驾车规划路线
   * @param {[Number, Number] | LngLat} startPos 起点经纬度坐标
   * @param {[Number, Number] | LngLat} endPos 终点经纬度坐标
   */
  drivingSearch (startPos, endPos, drivingOptions) {
    if (this.plugins.indexOf('AMap.Driving') === -1) return

    if (this.drivingInstance) this.drivingInstance.clear()

    drivingOptions = drivingOptions ? drivingOptions() : { options: {} }

    this.drivingInstance = new this.AMapInstance.Driving({
      map: this.map,
      policy: this.AMapInstance.DrivingPolicy.LEAST_TIME,
      outlineColor,
      ...drivingOptions.options
    })

    console.log('起点', startPos)
    console.log('终点', endPos)
    drivingOptions.beforeDrivingSearch && drivingOptions.beforeDrivingSearch()

    this.drivingInstance.search(startPos, endPos, (status, result) => {
      // result 即是对应的驾车导航信息，相关数据结构文档请参考  https://lbs.amap.com/api/javascript-api/reference/route-search#m_DrivingResult
      if (status === 'complete') {
        drivingOptions.drivingSearchComplete && drivingOptions.drivingSearchComplete(result)
        console.log('绘制驾车路线完成', result)
      } else {
        console.error('获取驾车数据失败：' + result)
      }
    })
  }

  /**
   * 步行规划路线
   * @param {[Number, Number] | LngLat} startPos 起点经纬度坐标
   * @param {[Number, Number] | LngLat} endPos 终点经纬度坐标
   */
  walkingSearch (startPos, endPos, walkingOptions) {
    if (this.plugins.indexOf('AMap.Walking') === -1) return

    if (this.walkingInstance) this.walkingInstance.clear()

    walkingOptions = walkingOptions ? walkingOptions() : { options: {} }

    this.walkingInstance = new this.AMapInstance.Walking({
      map: this.map,
      outlineColor,
      ...walkingOptions.options
    })

    console.log('起点', startPos)
    console.log('终点', endPos)
    walkingOptions.beforeWalkingSearch && walkingOptions.beforeWalkingSearch()

    this.walkingInstance.search(startPos, endPos, (status, result) => {
      // result 即是对应的驾车导航信息，相关数据结构文档请参考  https://lbs.amap.com/api/javascript-api/reference/route-search#m_WalkingResult
      if (status === 'complete') {
        walkingOptions.walkingSearchComplete && walkingOptions.walkingSearchComplete(result)
        console.log('绘制驾车路线完成', result)
      } else {
        console.error('获取驾车数据失败：' + result)
      }
    })
  }

  // 加载巡航器UI组件
  loadPathSimplifier () {
    if (this.AMapUIPlugins.indexOf('misc/PathSimplifier') === -1) return

    if (!AMapUI.PathSimplifier.supportCanvas) {
      console.log('当前环境不支持 Canvas！');
      return;
    }

    this.pathSimplifierIns = new AMapUI.PathSimplifier({
      zIndex: 119,
      //autoSetFitView:false,
      map: this.map, //所属的地图实例
      autoSetFitView: false,
      getPath: function (pathData, pathIndex) {

        return pathData.path;
      },
      getHoverTitle: function (pathData, pathIndex, pointIndex) {

        if (pointIndex >= 0) {
          //point
          return pathData.name + '，点：' + pointIndex + '/' + pathData.path.length;
        }

        return pathData.name + '，点数量' + pathData.path.length;
      },
      renderOptions: {
        renderAllPointsIfNumberBelow: -1, //绘制路线节点，如不需要可设置为-1
        pathNavigatorStyle: {
          width: 18,
          height: 36,
          content: AMapUI.PathSimplifier.Render.Canvas.getImageContent(carpng, () => {
            this.pathSimplifierIns.renderLater();
          },
            () => console.log('图片加载失败！')
          ),
          pathLinePassedStyle: {
            borderStyle: '#fff',
            strokeStyle: '#fff'
          },
        },
        pathLineStyle: {
          lineWidth: 0, // 4
          dirArrowStyle: true,
          strokeStyle: '#49cea1',
          borderWidth: 0,
          borderStyle: outlineColor
        },
        pathLineHoverStyle: {
          disableIfSelected: false
        },
        disableIfSelected: false,
        getPathStyle: function (pathItem, zoom) {
          var lineWidth = Math.round(4 * Math.pow(1.1, zoom - 8));
          return {
            pathLineStyle: {
              lineWidth: 0
            }
          }
        }
      },
    })
  }

  /**
   * 设定数据源数组，并触发重新绘制。data为空时将清除显示内容。
   * @param {data:Array} data
   */
  pathSetData (data) {
    console.log('巡航器路线数据', data)

    if (!this.pathSimplifierIns) return

    //设置数据
    this.pathSimplifierIns.setData(data);

    // this.pathSimplifierIns.setData([{
    //   name: '路线0',
    //   path: [
    //     [116.405289, 39.904987],
    //     [113.964458, 40.54664],
    //     [111.47836, 41.135964],
    //   ]
    // }]);
  }

  /**
   * 创建 线路 巡航器，创建前记得setData写入路线数据
   * @param {Number} index 索引 - 对应setData路线数据的第几条索引路线
   * @param {Object} opt 路线配置
   */
  createPathNavigator (index, opt) {
    //对第index条线路（即索引 index）创建一个巡航器
    var navg1 = this.pathSimplifierIns.createPathNavigator(index, {
      speed: 40, //巡航速度，单位千米/小时
      dirToPosInMillsecs: 200,
      ...opt
    });

    return navg1
  }

  // 司机距离乘客的距离 时间  描述
  distanceContent (path, isFrom) {
    let distance = null,
        content = '',
        duration = 0
    if (Array.isArray(path)) {
      distance = metreToKm(Math.round(this.AMapInstance.GeometryUtil.distanceOfLine(path)))
    } else {
      distance = path
    }

    // 距离不足100米显示司机即将到达
    if (distance <= 0.1) {
      content = isFrom ? '司机即将到达上车点' : '司机即将到达下车点'
    } else {
      duration = Math.round(distance / 30 * 60) // 默认按 30km/h 算时间

      content = `${isFrom ? '距你' : '剩余'}<span class="main-color">${distance}</span>公里 <span class="main-color">${duration}</span>分钟`
    }

    return {
      content,
      distance,
      duration
    }
  }

  /**
   * 两点之间的直线距离与时间
   * @param {LngLat} start_pos
   * @param {LngLat} stop_pos
   * @returns 公里
   */
  distanceOfTwoPosTime (start_pos, stop_pos) {
    console.log('是否调用这个函数')
   let dissolution= metreToKm(Math.round(this.AMapInstance.GeometryUtil.distance(start_pos, stop_pos)))
   let  duration = Math.round(dissolution / 30 * 60) // 默认按 30km/h 算时间
   console.log(dissolution,duration)
    return {
      dissolution,
      duration
    }
  
  }

  /**
   * 两点之间的直线距离
   * @param {LngLat} start_pos
   * @param {LngLat} stop_pos
   * @returns 公里
   */
  distanceOfTwoPos (start_pos, stop_pos) {
    return metreToKm(Math.round(this.AMapInstance.GeometryUtil.distance(start_pos, stop_pos)))
  }

  //注销地图对象，并清空地图容器
  destroy () {
    this.map.destroy()
  }

}

// 解析DrivingRoute对象，构造成AMap.Polyline的path参数需要的格式
LD_AMap.parseRouteToPath = function (route) {
  var path = []

  for (var i = 0, l = route.steps.length; i < l; i++) {
    var step = route.steps[i]

    for (var j = 0, n = step.path.length; j < n; j++) {
      path.push(step.path[j])
    }
  }

  return path
}


/**
 * 经纬度转换
 * 各坐标系别名 — 火星坐标（GCJ-02、国测局经纬度坐标系）, 百度坐标（BD09），GPS（wgs84）
 * @param {[Number, Number] | LngLat} pos 经纬度
 * @param {String} type 用于说明是哪个服务商的坐标,可选值有：gps:GPS原始坐标；baidu：百度经纬度；mapbar：图吧经纬度；
 * @returns {Promise data: [Number, Number] | LngLat} 火星坐标系
 */
LD_AMap.convertFrom = function (pos, type) {
  return new Promise((resolve, reject) => {
    if (window.AMap) {
      if (AMap.convertFrom) {
        AMap.convertFrom(pos, type, (status, result) => {
          const { lng, lat } = result.locations ? result.locations[0] : {}
          resolve({ lng, lat })
        })
      }
    } else {
      AMapLoader.load({ //首次调用 load
        key: AppKey,//首次load key为必填
        version: '2.0',
      }).then(AMap => {
        AMap.convertFrom(pos, type, (status, result) => {
          const { lng, lat } = result.locations ? result.locations[0] : {}
          resolve({ lng, lat })
        })
      }).catch((e) => {
        reject(e)
      })
    }
  })
}

/**
 * 地图导航 综合三端处理方案
 * H5使用高德地图导航
 * startPoint 和 stopPoint必传其中一个
 * @param {Point} startPoint 导航目的地坐标 格式 { lng, lat } - 百度坐标系。不传入则以当前位置的经纬度规划路线
 * @param {String} startName 导航出发地描述。不传入或为否判断为 "我的位置"
 * @param {Point} stopPoint 导航起始地坐标 格式 { lng, lat } - 百度坐标系。不传入则以当前位置的经纬度规划路线
 * @param {String} stopName 导航目的地描述。不传入为 "我的位置"
 * @param {String} type 用于说明是哪个服务商的坐标,可选值有：gps:GPS原始坐标；baidu：百度经纬度；mapbar：图吧经纬度；
 * @param {String} mode 出行方式：驾车：mode=car,公交:：mode=bus；步行：mode=walk；骑行：mode=ride；
 */
LD_AMap.openMap = async function (startPoint, startName, stopPoint, stopName, type, mode = 'car') {
  if (!startName || !startPoint) {
    startName = '我的位置'
    startPoint = { lng: '', lat: '' }
  }

  if (isAndroid() || isIOS()) {
    const start_pos_gps = bd09towgs84(startPoint.lng, startPoint.lat)
    const stop_pos_gps = bd09towgs84(stopPoint.lng, stopPoint.lat)

    openSysMap(
      { lng: start_pos_gps[0], lat: start_pos_gps[1] },
      startName,
      { lng: stop_pos_gps[0], lat: stop_pos_gps[1] },
      stopName
    )

  } else if (isH5()) {
    let from = '',
        to = ''

    if (startPoint && startPoint.lng && startPoint.lat) {
      let start_pos_gps = await LD_AMap.convertFrom([startPoint.lng, startPoint.lat], type)
      from = `${start_pos_gps.lng},${start_pos_gps.lat},${startName}`
    }

    if (stopPoint && stopPoint.lng && stopPoint.lat) {
      let stop_pos_gps = await LD_AMap.convertFrom([stopPoint.lng, stopPoint.lat], type)
      to = `${stop_pos_gps.lng},${stop_pos_gps.lat},${stopName}`
    }

    const url = `//uri.amap.com/navigation?from=${from}&to=${to}&mode=${mode}&src=${window.location.href}&coordinate=gaode&callnative=1`
    window.location.href = url
  }
}

export default LD_AMap
